<template>
  <v-card :color="cardColor">
    <v-card-title>
      <div class="layout row ma-0">
        <div class="subheading">{{ title }}</div>
        <v-spacer></v-spacer>
        <div class="caption">
          <v-icon>trending_up</v-icon>
          {{ subTitle }}
        </div>
      </div>
    </v-card-title>
    <v-skeleton-loader
      :loading="loading"
      transition="scale-transition"
      height="320"
      type="card"
    >
      <v-responsive>
        <apexchart
          type="radar"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </v-responsive>
    </v-skeleton-loader>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import DashService from "@/services/dashboard.service";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    title: String,
    subTitle: String,
    icon: String,
    cardColor: {
      type: String,
      default: "white",
    },
    iconColor: {
      type: String,
      default: "success",
    },
    courseId: Number,
  },
  created() {
    DashService.getPerformanceByTopics(this.courseId).then((res) => {
      // console.log(res.data.map(a => a.topic))
      this.chartOptions.labels = res.data.map((a) =>
        this.truncateString(a.topic, 15),
      );
      this.series[0].data = res.data.map((a) => a.percent);
      this.loading = false;
    });
  },
  data() {
    return {
      loading: true,
      chartOptions: {
        labels: null,
        title: {
          text: "",
        },
        plotOptions: {
          radar: {
            size: 140,
            polygons: {
              strokeColor: "#e9e9e9",
              fill: {
                colors: ["#fff", "#fff"],
              },
            },
          },
        },
        yaxis: {
          max: 100,
          min: 0,
          tickAmount: 4,
        },
      },
      series: [
        {
          name: "Média (%)",
          data: null,
        },
      ],
    };
  },
  computed: {},
  methods: {
    truncateString(str, num) {
      // If the length of str is less than or equal to num
      // just return str--don't truncate it.
      if (str.length <= num) {
        return str;
      }
      // Return str truncated with '...' concatenated to the end of str.
      return str.slice(0, num) + "...";
    },
  },
};
</script>

<style></style>
